import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMediafireComponent } from './simple-icons-mediafire.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMediafireComponent ],
    exports:      [ SimpleIconsMediafireComponent ],
    bootstrap:    []
})
export class SimpleIconsMediafireModule {}
